module.exports = __webpack_public_path__ + "static/unplugged.f9e9b147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/examples/microwave-example/unplugged.jpg
// module id = 1009
// module chunks = 240162396545425